import { render, staticRenderFns } from "./AttributeFormEdit.vue?vue&type=template&id=af5f5410&"
import script from "./AttributeFormEdit.vue?vue&type=script&lang=js&"
export * from "./AttributeFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports